import { StyledBurgerButton } from './style'

const BurgerButton = ({ onClick, ...props }) => {
  return (
    <StyledBurgerButton
      className="burger-btn"
      type="button"
      onClick={onClick}
      {...props}
    >
      <span></span>
    </StyledBurgerButton>
  )
}

export default BurgerButton
